module.exports = __webpack_public_path__ + "static/media/img-access-entrance.30b19f6d.jpg";